<template>
  <div>
    <el-dialog :title="['add', 'addTemplate'].includes(type) ? '添加辅料' : '编辑辅料'" :visible.sync="dialogVisible"
      width="690px" @close="handleClose">
      <div class="add_content">
        <div class="add_table">
          <div class="add_table_title">辅料明细</div>
          <div class="add_table_cell">
            <div class="add_table_cell_item" v-for="(item, index) in list" :key="index">
              <div class="add_table_cell_item_name">
                <el-select :ref="'nameInput' + index" class="name_input" v-model="item.oriName" filterable remote
                  reserve-keyword placeholder="辅料名" :remote-method="remoteMethod"
                  @change="selectIngredient(index, item, $event)"
                  @keydown.left.native.prevent="numberInputMove('left', index)"
                  @keydown.right.native.prevent="numberInputMove('right', index)">
                  <el-option v-for="item in options" :key="item.ingredientsName" :label="item.ingredientsName"
                    :value="item.ingredientsName">
                    <div class="ingredients_option">
                      <div>{{ item.ingredientsName }}</div>
                      <div>{{ item.unit }}</div>
                    </div>
                  </el-option>
                </el-select>
                <div class="number_warp">
                  <el-input :ref="'numInput' + index" v-model="item.oriNum" placeholder="用量"
                    @keydown.enter.native="numberInputMove('right', index)"
                    @keydown.left.native.prevent="numberInputMove('left', index)"
                    @keydown.right.native.prevent="numberInputMove('right', index)" />
                  <div class="flex-sh">{{item.oriUnit}}</div>
                </div>
              </div>
              <SelectPanel width="100%" placeholder="煎法" :columnsNum="4" :maxlength="20" v-model="item.oriHandling"
                :options="handlingOptions"
                :class="{ prescription_decoction: true, prescription_decoction_hide: [null, undefined, ''].includes(item.oriHandling) }">
              </SelectPanel>
              <i class="el-icon-close close-item pointer" style="font-size: 14px; color:#9AA0A8"
                v-if="list.length != index + 1" @click="removeDrug(index)"></i>
            </div>
          </div>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="handleClose">取 消</el-button>
        <el-button type="primary" v-if="type == 'addTemplate'" plain @click="saveAndUse">存为模版并使用</el-button>
        <el-button type="primary" v-if="['addTemplate', 'add'].includes(type)" @click="use">使用</el-button>
        <el-button type="primary" v-if="type == 'editIngredient'" @click="use">保存</el-button>
        <el-button type="primary" v-if="type == 'editTemplate'" @click="save">保存</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { debounce, deepClone, isNull, isEmptyArray } from '@/utils/validateBase';
import SelectPanel from '@/components/SelectPanel.vue'
import { handlingOptions } from '@/utils/const'
import { ingredientsList, ingredientsAddTemplate, ingredientTemplateEdit } from '@/api/ingredients'
export default {
  components: { SelectPanel },
  props: {
    doctorId: {
      type: String | Number,
      value: ''
    },
  },
  data() {
    return {
      dialogVisible: false,
      value: '',
      options: [],
      list: [],
      handlingOptions: handlingOptions,
      drugItemIndex: null,
      focusIndex: 0,//搜索框里输入框聚焦的索引  0名字 1数量
      type: 'addTemplate', // add 新增 addTemplate 新增模版 editIngredient编辑辅料 editTemplate编辑模版
    }
  },
  methods: {
    handleClose() {
      this.drugItemIndex = null
      this.dialogVisible = false
      this.list = []
    },
    remoteMethod: debounce(async function (val) {
      if (isNull(val)) {
        this.options = []
        return
      }
      let { code, rows } = await ingredientsList({ searchValue: val })
      if (code == 200) {
        this.options = rows || []
      }
    }, 300),
    open(obj) {
      let { index, ingredient, type, iteId } = obj
      this.drugItemIndex = index
      this.type = type
      this.iteId = isNull(iteId) ? '' : iteId
      if (!isNull(ingredient) && !isEmptyArray(ingredient)) {
        this.list = deepClone(ingredient)
      }
      this.list.push({ oriHandling: '', oriName: '', oriNum: '', oriUnit: '' })
      this.dialogVisible = true
    },
    selectIngredient: debounce(function (index, item, val) {
      const someFlag = this.list.some((item, i) =>
        this.list.findIndex(i => i.oriName === item.oriName) !== i
      );
      if (someFlag) {
        this.$message.error('不能重复添加')
        item.oriName = ''
        item.oriUnit = ''
        item.hisId = ''
        return;
      }
      let obj = this.options.find(v => { return v.ingredientsName == val })
      item.oriName = obj.ingredientsName
      item.oriUnit = obj.unit
      item.hisId = obj.ingredientsId
      let flagIndex = this.list.findIndex(v => { return isNull(v.oriName) })
      if (flagIndex == -1) {
        this.list.push({ oriHandling: '', oriName: '', oriNum: '', oriUnit: '' })
      }
      this.options = []
      this.$nextTick(() => {
        this.$refs[`numInput${index}`][0].select()
        this.focusIndex = 1
      })
    }, 300, true),
    saveAndUse: debounce(async function () {
      let ingredientsTemplateDetails = deepClone(this.list)
      ingredientsTemplateDetails = ingredientsTemplateDetails.filter(v => { return !isNull(v.oriName) })
      let index = ingredientsTemplateDetails.findIndex(v => { return isNull(v.oriNum) })
      if (index != -1) {
        return this.$message.error('请填写数量')
      }
      let params = { doctorId: this.doctorId, ingredientsTemplateDetails }
      let { code, data } = await ingredientsAddTemplate(params)
      if (code == 200) {
        this.$message.success('保存成功')
      }
      this.$emit('useIngredient', { ingredientsTemplateDetails, drugItemIndex: this.drugItemIndex })
    }, 500, true),
    use: debounce(async function () {
      let ingredientsTemplateDetails = deepClone(this.list)
      ingredientsTemplateDetails = ingredientsTemplateDetails.filter(v => { return !isNull(v.oriName) })
      let index = ingredientsTemplateDetails.findIndex(v => { return isNull(v.oriNum) })
      if (index != -1) {
        return this.$message.error('请填写数量')
      }
      this.$emit('useIngredient', { ingredientsTemplateDetails, drugItemIndex: this.drugItemIndex })
    }, 500, true),
    save: debounce(async function () {
      let ingredientsTemplateDetails = deepClone(this.list)
      ingredientsTemplateDetails = ingredientsTemplateDetails.filter(v => { return !isNull(v.oriName) })
      let index = ingredientsTemplateDetails.findIndex(v => { return isNull(v.oriNum) })
      if (index != -1) {
        return this.$message.error('请填写数量')
      }
      let params = { doctorId: this.doctorId, ingredientsTemplateDetails, iteId: this.iteId }
      let { code, data } = await ingredientTemplateEdit(params)
      if (code == 200) {
        this.$message.success('保存成功')
      }
      this.$emit('editTemplateSuccess')
      this.handleClose()
    }, 500, true),
    removeDrug(index) {
      this.list.splice(index, 1)
    },
    numberInputMove(type, index) {
      this.options = []
      if (type == 'left') {
        if (this.focusIndex == 1) {
          this.$refs[`nameInput${index}`][0].focus()
          this.focusIndex = 0
        } else if (this.focusIndex == 0) {
          if (index == 0) return;
          index = index - 1
          this.$refs[`numInput${index}`][0].select()
          this.$refs[`nameInput${index + 1}`][0].blur()
          this.focusIndex = 1
        }
      } else if (type == 'right') {
        if (this.focusIndex == 0) {
          this.$refs[`numInput${index}`][0].select()
          this.$refs[`nameInput${index}`][0].blur()
          this.focusIndex = 1
        } else if (this.focusIndex == 1) {
          if (index == this.list.length - 1) return;
          index++
          this.$refs[`nameInput${index}`][0].focus()
          this.focusIndex = 0
        }
      }
    },
  }
}
</script>

<style lang="less" scoped>
.add_content {
  max-height: 600px;
  padding: 24px;
  overflow: auto;
  box-sizing: border-box;
}

.add_table {
  border: 1px solid #D3D3D5;
  border-radius: 2px;
}

.add_table_title {
  height: 40px;
  background: #F0F1F3;
  line-height: 40px;
  font-weight: 600;
  font-size: 14px;
  color: #000000;
  padding-left: 12px;
  border-bottom: 1px solid #D3D3D5;
}

.add_table_cell {
  display: flex;
  flex-wrap: wrap;
}

.add_table_cell_item {
  width: 160px;
  height: 60px;
  border-right: 1px dashed #D3D3D5;
  border-bottom: 1px dashed #D3D3D5;
  padding: 0 10px;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  justify-content: center;
  position: relative;
}

.close-item {
  position: absolute;
  top: 2px !important;
  right: 2px !important;
  font-size: 12px;
  opacity: 0;
}

.close-item:hover {
  padding: 2px;
  top: 0px !important;
  right: 0px !important;
  background-color: #DEDFE1;
  border-radius: 50%;
}

.add_table_cell_item:hover .close-item {
  opacity: 1;
}

.add_table_cell_item:hover .prescription_decoction_hide {
  visibility: visible;
}

.add_table_cell_item_name {
  display: flex;
  justify-content: space-between;
}

.name_input /deep/.el-input__inner {
  max-width: 84px;
  height: 20px;
  padding: 0;
  border: none;
}

.number_warp {
  display: flex;
  align-items: center;
  flex-shrink: 0;
}

.number_warp /deep/.el-input__inner {
  max-width: 28px;
  height: 20px;
  padding: 0;
  border: none;
  margin-right: 8px;
  text-align: right;
}

.ingredients_option {
  width: 100px;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.prescription_decoction {
  height: 16px;
}

.prescription_decoction_hide {
  visibility: hidden;
}

.prescription_decoction_hide_most {
  visibility: hidden !important;
}

.prescription_decoction /deep/.input .el-input__inner {
  padding: 0;
  height: 16px;
  font-size: 12px;
}

.prescription_decoction /deep/.input .el-input__inner:hover,
.prescription_decoction /deep/.isFocus .el-input__inner {
  border-bottom: 1px solid transparent;
}
</style>